import React from "react";
import TaskColumnContainer from "components/common/TaskColumnContainer";
import SpaceTaskCard from "components/common/SpaceTaskCard";
import {
    Space,
    SpaceTaskFilters,
    SpaceTaskStatusEnum,
    TaskScheduleTypeEnum,
} from "redux/Ldb/types/spaceTypes";
import { UseGetSpaceTasksReturn } from "hooks/spaceHooks/useGetSpaceTasks";
import IconButton from "components/common/IconButton";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

type SpaceTaskOneTimeListProps = {
    spaceData: Space;
    getSpaceTaskListQuery: UseGetSpaceTasksReturn;
    filters: SpaceTaskFilters;
    setFilters: (filters: SpaceTaskFilters) => void;
    toggleOpenSpaceTaskAddModal: () => void;
    setAddStatus: (addStatus: SpaceTaskStatusEnum | string) => void;
    setTaskType: (type: string) => void;
    setTaskId: (id: string) => void;
};

const SpaceTaskOneTimeList = (props: SpaceTaskOneTimeListProps) => {
    const {
        getSpaceTaskListQuery,
        filters,
        setFilters,
        toggleOpenSpaceTaskAddModal,
        setAddStatus,
        setTaskType,
        setTaskId,
    } = props;

    const navigate = useNavigate();
    const { spaceId } = useParams();
    const [searchParams] = useSearchParams();
    const tabId = searchParams.get("tab");
    const allTasks = [
        {
            title: "To Do",
            type: SpaceTaskStatusEnum.todo,
            icon: <i className={`ri-hourglass-line text-slate-500 text-base`}></i>,
            total: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.todo
            )?.length,
            tasks: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.todo
            ),
            borderColor: "#64748B",
        },
        {
            title: "In Progress",
            type: SpaceTaskStatusEnum.inProgress,
            icon: <i className={`ri-hourglass-line text-[#FF8A0099] text-base`}></i>,
            total: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.inProgress
            )?.length,
            tasks: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.inProgress
            ),
            borderColor: "#FF8A00",
        },
        {
            title: "Completed",
            type: SpaceTaskStatusEnum.completed,
            icon: <i className={`ri-check-double-line text-[#0AAD0A] text-base`}></i>,
            total: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.completed
            )?.length,
            tasks: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.completed
            ),
            borderColor: "#0AAD0A",
        },
        {
            title: "Failed/Rejected",
            type: SpaceTaskStatusEnum.failed,
            icon: <i className={`ri-close-line text-[#E4281D] text-base`}></i>,
            total: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.failed
            )?.length,
            tasks: getSpaceTaskListQuery?.data?.tasks?.filter(
                (task) => task?.status === SpaceTaskStatusEnum.failed
            ),
            borderColor: "#E4281D",
        },
    ];

    return (
        <div
            className="grid grid-cols-4 space-x-1.5"
            onClick={() => {
                setFilters({
                    ...filters,
                    taskType: TaskScheduleTypeEnum.oneTime,
                });
            }}
        >
            {allTasks?.map((item, idx) => (
                <TaskColumnContainer
                    key={idx}
                    title={item.title}
                    icon={item.icon}
                    total={item.total}
                    borderColor={item.borderColor}
                    endTitle={
                        <IconButton
                            color="secondary"
                            size="small"
                            onClick={() => {
                                toggleOpenSpaceTaskAddModal();
                                setAddStatus(item.type);
                            }}
                        >
                            <i className="ri-add-line"></i>
                        </IconButton>
                    }
                >
                    <>
                        {item?.tasks?.map((task, idx) => {
                            return (
                                <SpaceTaskCard
                                    title={task?.name}
                                    description={task?.description}
                                    startDate={new Date(task?.schedule?.startAt)?.toISOString()}
                                    endDate={
                                        task?.schedule?.endAt
                                            ? new Date(task?.schedule?.endAt)?.toISOString()
                                            : ""
                                    }
                                    createdBy={
                                        task?.createdBy?.kind === "synth"
                                            ? "Synth"
                                            : task?.createdBy?.ldb?.fullName || "" //TODO: include guest name
                                    }
                                    onClick={() => {
                                        setTaskType("recurring");
                                        setTaskId(task?._id);
                                        navigate(
                                            `/spaces/${spaceId}?tab=${tabId || 3}&taskId=${
                                                task?._id
                                            }`
                                        );
                                    }}
                                />
                            );
                        })}
                    </>
                </TaskColumnContainer>
            ))}
        </div>
    );
};

export default SpaceTaskOneTimeList;
